jQuery(document).ready(function($) {
    'use strict';

    // Define menu specific variables
    var $w = $(window), $body = $('body'),
        $defaultMenuToggle = $('.menu-toggle-container.default'),
        $stickyMenu = $('.menu-sticky.main-menu-container'),
        $fixedMenuToggle = $('.menu-toggle-container.fixed'),
        $fullScreenMenu = $('.full-screen-menu-container'),
        $firstBlock = $('.block').first(),
        currentScroll = 0,
        scrollTrigger = 300;
    if ($firstBlock.length) {
      scrollTrigger = Math.round($firstBlock.offset().top + $firstBlock.height()/2);
    }

    // Toggle full screen menu when user clicks the toggle in the main menu
    $defaultMenuToggle.on('click', function() {
        if ($fullScreenMenu.hasClass('visible')) {
          $fullScreenMenu.removeClass('visible');
          $fixedMenuToggle.removeClass('active');
          $body.removeClass('lock-scroll menu-open');
          $w.scrollTop(currentScroll);
        } else {
          $fullScreenMenu.addClass('visible');
          $fixedMenuToggle.addClass('active');
          $body.addClass('menu-open');
          currentScroll = $w.scrollTop();
          setTimeout(function() {
            $body.addClass('lock-scroll');
          }, 300);
        }
    });

    $(document).on('keyup', function(e) {
      var evt = e || window.event, isEsc = false;
      if ("key" in evt) {
        isEsc = (evt.key==='Escape' || evt.key==='Esc');
      } else {
        isEsc = (evt.keyCode === 27);
      }
      if (isEsc) {
        if ($fullScreenMenu.hasClass('visible')) {
          $defaultMenuToggle.trigger('click');
        }
      }
    });

    // Toggle full screen menu when user clicks fixed menu toggle
    $fixedMenuToggle.on('click', function() {
      $defaultMenuToggle.trigger('click');
    });

    $fullScreenMenu.on('click', function() {
      if ($fullScreenMenu.hasClass('visible')) {
        $defaultMenuToggle.trigger('click');
      }
    });

    $fullScreenMenu.on('click', 'a', function(e) {
      e.stopPropagation();
      if ($fullScreenMenu.hasClass('visible')) {
        var $menuItem = $(this).parent('.menu-item');
        if ($menuItem.hasClass('menu-item-has-children')) {
          e.preventDefault();
          $menuItem.toggleClass('active').find('.sub-menu').slideToggle(300);
        }
      }
    });

    $w.on('resize', function() {
      if ($firstBlock.length) {
        scrollTrigger = Math.round($firstBlock.offset().top + $firstBlock.height()/2);
      }
    });

    // Toggle menu visibility based on scroll position
    $w.on('scroll', function() {
      if (!$body.hasClass('lock-scroll')) {
        if (($w.scrollTop() > scrollTrigger && !$stickyMenu.hasClass('visible') )) {
            $stickyMenu.addClass('visible');
            $stickyMenu.addClass('scroll-in-view');
        } else if ( $w.scrollTop() < scrollTrigger ) {
            $stickyMenu.removeClass('scroll-in-view');
            if ( !$fixedMenuToggle.hasClass('active') ) {
                $stickyMenu.removeClass('visible');
            }
        }
      }
    });

    $w.trigger('scroll');
});

jQuery(window).on('load',function(){
  jQuery('body').addClass('loaded');
});